export default __webpack_public_path__ + "d01f2d0442c8b2dfbb887dbfe3b911c9.ttf";